var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('container',[_c('div',{staticClass:"stats-wrapper"},[_c('div',{staticClass:"headline"},[_c('p',[_vm._v("StudySync is owned by Imagine Learning. If you would like to contact us please visit us "),_c('a',{attrs:{"href":"https://www.imaginelearning.com/about/contact-us/"}},[_vm._v("here")]),_vm._v(".")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f477655a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurCompany/AboutIntro.vue
// module id = null
// module chunks = 